/* eslint-disable @typescript-eslint/naming-convention */
import { ModelValidationMetadataMap } from 'app/core/validation';

export const portalpracticeValidationMetadata: ModelValidationMetadataMap = {
  portalPractice : {
    properties: {
      practiceName: {
        required: true,
        displayName: 'Practice name',
      }
    }
  }
};
